import { styled, css } from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  position: relative;
  user-select: none;
  .button {
    &:disabled {
      &:hover {
        background: transparent;
      }
    }
  }

  .text {
    user-select: none;
  }

  .spinner {
    padding: 0.75rem 0;
  }
`;

export const AltLabelBadge = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    width: 1rem;
    height: 1rem;
    padding: 0.125rem;
    justify-content: center;
    align-items: center;
    gap: 3.625rem;
    position: absolute;
    color: ${colors.brandLight};
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.75rem;
    right: 0;
    top: 0;
    border-radius: 1rem;
    background-color: ${colors.brandPrimary};
  `}
`;
